export default __webpack_public_path__ + "static/media/img-0505-holy-see-premium-face.0376b1cc.png";